module.exports = __webpack_public_path__ + "img/1980pages-mobile.80fed850.jpg";